// extracted by mini-css-extract-plugin
export default {"loading-pane":"Loader_loading-pane__qy9T2","loader":"Loader_loader__2wcIb","spin":"Loader_spin__ej-fP"};